export default {
  // serverURL : "http://server.avijehdaroo.ir:3021",
  // serverURL : "http://server.avijehdaroo.ir:3025",
  // serverURL : "https://lab.chbk.run/",
  // serverURL : "https://lab.chabk.app/",
  // serverURL : "https://docker-mk6yl4.chbk.app",
  // serverURL : "http://195.211.44.197:3000/",
  // serverURL : "https://localhost:3000/api/",
  // serverURL : "https://localhost/api/",
  serverURL : "https://qajapp.ir/api/",
}